import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
declare var require: any;

import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
const htmlToPdfmake = require("html-to-pdfmake");
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

import { Router, ActivatedRoute } from '@angular/router';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { AttachmentErrorDialogComponent } from '../../attachment-error-dialog/attachment-error-dialog.component';
import { CommonFunction } from '../../common-function';
import { Status } from '../../interface/common-interface';
import { ViewattachmentComponent } from '../../internal-user/viewattachment/viewattachment.component';
import { ProjectConstants } from '../../project-constants';
import { AssignedGrievanceViewReplyService } from '../assign-grievances/assgined-grievance-view-reply/assigned-grievance-view-reply.service';

@Component({
  selector: 'app-master-grievance-view',
  templateUrl: './master-grievance-view.component.html',
  styleUrls: ['./master-grievance-view.component.scss'],
})
export class MasterGrievanceViewComponent implements OnInit {
  myid: any;
  grievanceHistory = [];
  grievanceId: any;
  boardName: any;
  grievanceType: any;
  id: any;
  subject: any;
  remark: any;
  resstatus: any;
  document; any;
  createdOn: any;
  isShowReply: boolean = false;
  docType: string;
  userType: string;
  applicationName: any;
  lotteryName: any;
  paymentAmount: any;
  replyCtrl = new FormControl();
  documentList: any = []
  userId: any;
  userName: any;
  umobileNo: any;
  uemail: any;
  upan: any;
  progressSpinnerDialog: any = null;
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  @ViewChild('attachments') attachments: any;
  @ViewChild('attachments1') attachments1: any;
  @ViewChild('attachments2') attachments2: any;
  isShowClose: boolean = false;
  isShowClose1: boolean = false;
  isShowClose2: boolean = false;

  filefirst: boolean = false;
  fileSecond: boolean = false;
  filethird: boolean = false;
  file: File = null;
  file1: File = null;
  file2: File = null;
  fileBase64: any;
  fileBase1_64: any;
  fileBase2_64: any;
  filenm: any;
  filenm1: any;
  filenm2: any;

  protected statuses: Status[] = [];
  public statusCtrl: FormControl = new FormControl();
  public statusFilterCtrl: FormControl = new FormControl();
  public filteredStatus: ReplaySubject<Status[]> = new ReplaySubject<Status[]>(1);

  protected _onDestroy = new Subject<void>();
  constructor(public assignedGrievanceReplyService: AssignedGrievanceViewReplyService,
    public router: Router,
    private commonFunction: CommonFunction,
    public dialog: MatDialog,
    public activatedRoute: ActivatedRoute) { }

  async ngOnInit() {
    //get id through activatedroute
    this.id = this.activatedRoute.snapshot.paramMap.get('myid');
    //load grievance history, statuses, auto scroll history
    this.loadGrievanceHistory();
    this.loadStatus();
    this.scrollToBottom();
    //
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }


  //auto scroll history
  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }
  //

  //on distroy
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
  //

  //load status 
  async loadStatus() {
    this.displayProgressSpinner();
    const response: any = await this.assignedGrievanceReplyService.loadStatus();
    this.progressSpinnerDialog.close()

    if (response != null && !response.error) {
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.statuses = response
        //set status in array  
        this.statusCtrl.setValue(this.statuses[10]);
        this.filteredStatus.next(this.statuses.slice());
        this.statusFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterStatus();
          });
        //
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/master-grievance-list")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/master-grievance-list")
    }
  }
  //

  //filter statuses
  protected filterStatus() {
    if (!this.statuses) {
      return;
    }
    let search = this.statusFilterCtrl.value;
    if (!search) {
      this.filteredStatus.next(this.statuses.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredStatus.next(
      this.statuses.filter(status => status.statusName.toLowerCase().indexOf(search) > -1)
    );
  }
  //

  //load grievance history
  async loadGrievanceHistory() {
    const data = {
      "complaintId": this.id
    }
    // this.displayProgressSpinner();
    const response: any = await this.assignedGrievanceReplyService.loadMasterGrievanceHistory(data);
    // this.progressSpinnerDialog.close()

    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        if (response.tabUserGrievance.length != 0) {
          var type;
          this.grievanceId = response.tabUserGrievance.pkUsgrid;
          this.boardName = response.tabUserGrievance.boardName;
          this.grievanceType = response.tabUserGrievance.grivType;
          this.subject = response.tabUserGrievance.usGriSubject;
          this.remark = response.tabUserGrievance.usGriDetails;
          this.createdOn = response.tabUserGrievance.createdOn;
          if (response.tabUserGrievance.internalUserId == null) {
            this.userId = response.tabUserGrievance.fkLotteryUserRegid
          } else {
            this.userId = response.tabUserGrievance.internalUserId
          }
          this.upan = response.tabUserGrievance.historyuserPanNo

          // this.userId=response.tabUserGrievance.
          this.userName = response.tabUserGrievance.historyuserName
          // this.umobileNo = this.mask_mobile(response.tabUserGrievance.historyuserMobileNo);
          this.umobileNo = response.tabUserGrievance.historyuserMobileNo;

          this.uemail = response.tabUserGrievance.historyuserEmail
          // this.grievanceHistory = response.tabGrievanceHistory.sort((a, b) => a.pkGhid > b.pkGhid ? 1 : -1)
          this.grievanceHistory = response.tabGrievanceHistory.map((item) => {
            if (item.ghDocument1 != null) {
              item.ghDocument1 = item.ghDocument1
            }
            if (item.ghDocument2 != null) {
              item.ghDocument2 = item.ghDocument2
            }
            if (item.ghDocument3 != null) {
              item.ghDocument3 = item.ghDocument3
            }
            return item
          })
          this.resstatus = response.tabUserGrievance.statusName;
          this.applicationName = response.tabUserGrievance.applicationNo
          this.lotteryName = response.tabUserGrievance.lotteryName
          this.paymentAmount = response.tabUserGrievance.onlinePaymentName

          if (response.tabUserGrievance.usGriDocument1 != null) {
            this.documentList.push(response.tabUserGrievance.usGriDocument1)
          }
          if (response.tabUserGrievance.usGriDocument2 != null) {
            this.documentList.push(response.tabUserGrievance.usGriDocument2)
          }
          if (response.tabUserGrievance.usGriDocument3 != null) {
            this.documentList.push(response.tabUserGrievance.usGriDocument3)
          }
          type = response.tabUserGrievance.usGriUserType;
          if (type == "MU") {
            this.userType = ProjectConstants.userTypeMhadaUser
          } else if (type == "LU") {
            this.userType = ProjectConstants.userTypeLotteryUser
          }
        }
      } else if (response.status == ProjectConstants.responseStatusFailure) {
        if (response.code == ProjectConstants.authanticationFailedCode) {
          await this.commonFunction.errorToast(ProjectConstants.authanticationFailedMsg, true, "secure/master-grievance-list")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/master-grievance-list")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/master-grievance-list")
    }
  }
  //

  mask_mobile(number) {
    let mask = ''
    if (number != null) {
      for (let i = 1; i <= number.length - 4; i++) {
        mask += '*'
      }
      number = mask + number.slice(6, 10);

      return number
    } else {
      return number
    }

  }
  // mask_email(mail) {
  //   if (mail != null) {
  //     const [name, domain] = mail.split('@');
  //     const { length: len } = name;
  //     const maskedName = name[0] + '****' + name[len - 1];
  //     const maskedEmail = maskedName + '@' + domain;
  //     return maskedEmail
  //   } else {
  //     return mail
  //   }
  // }

  //view attached document when click on eye icon
  async ViewdownloadAttachment(ghDocument) {
    if (ghDocument.split(".")[1] == 'jpg' || ghDocument.split(".")[1] == 'jpeg' || ghDocument.split(".")[1] == 'png') {
      this.docType = "image/" + ghDocument.split(".")[1]
    } else if (ghDocument.split(".")[1] == 'pdf') {
      this.docType = "application/pdf"
    }
    this.displayProgressSpinner();
    const response: any = await this.assignedGrievanceReplyService.downloadAttachment(ghDocument);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        const dialog = this.dialog.open(ViewattachmentComponent, {
          disableClose: true,
          width: "600px",
          data: [response.imgResponseString, this.id, this.docType, ghDocument]
        });
      } else if (response.status == ProjectConstants.responseStatusFailure) {
        if (response.code == ProjectConstants.noAbleToDownloadErCode) {
          await this.commonFunction.errorToast(ProjectConstants.noAbleToDownloadErMsg, false, "")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/master-grievance-list")
        }
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/master-grievance-list")
    }
  }
  //

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  //download attachment directly
  async downloadAttachment(ghDocument) {
    if (ghDocument.split(".")[1] == 'jpg' || ghDocument.split(".")[1] == 'jpeg' || ghDocument.split(".")[1] == 'png') {
      this.docType = "image/" + ghDocument.split(".")[1]
    } else if (ghDocument.split(".")[1] == 'pdf') {
      this.docType = "application/pdf"
    }
    this.displayProgressSpinner();
    const response: any = await this.assignedGrievanceReplyService.downloadAttachment(ghDocument);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        const byteArray = new Uint8Array(
          atob(response.imgResponseString)
            .split("")
            .map((char) => char.charCodeAt(0))
        );
        let blob = new Blob([byteArray], { type: this.docType });
        var src = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = src;
        const date = new Date().toDateString(),
          time = new Date().getTime()
        link.download = this.id + "_" + date + "_" + time +
          '.' + ghDocument.split('.').pop();
        link.click();
        await this.commonFunction.successToast(ProjectConstants.fileSuccessToastMsg, false, "")
      } else if (response.status == ProjectConstants.responseStatusFailure) {
        if (response.code == ProjectConstants.noAbleToDownloadErCode) {
          await this.commonFunction.errorToast(ProjectConstants.noAbleToDownloadErMsg, false, "")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/master-grievance-list")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/master-grievance-list")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/master-grievance-list")
    }
  }
  //

  @ViewChild('pdfTable') pdfTable!: ElementRef;
  exportPdf() {
    const pdfTable = this.pdfTable.nativeElement;
    var html = htmlToPdfmake(pdfTable.innerHTML);
    const documentDefinition = { content: html };
    pdfMake.createPdf(documentDefinition).download("Grievance History Report.pdf");
  }
}



